import { Component, Input } from '@angular/core';
import { PlanDefaultValues, PlanModel } from '../plan';
import { PlanService } from 'src/app/services/plan.service';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faBell } from '@fortawesome/free-solid-svg-icons';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
    selector: 'app-plan-details-form',
    templateUrl: './plan-details-form.component.html',
    styleUrls: ['./plan-details-form.component.scss'],
    standalone: false
})
export class PlanDetailsFormComponent {


  @Input() planDetails: PlanModel = PlanDefaultValues();
  @Input() isSubmitted: boolean = false;
  planAndReminderSchedule: any[] = []
  planCheckListItems: any[] = []
  selectedItems: any[] = [];
  rowNums = 2
  colNums = 150
  daysOfWeek: any[] = []
  datesOfMonth: any[] = []
  translations:any

  private readonly scheduleTranslationKeys: Record<number, string> = {
    1: 'scheduleTodayText',
    2: 'scheduleTomorrowText',
    3: 'scheduleDailyText',
    4: 'scheduleWeeklyText',
    5: 'scheduleMonthlyText',
    6: 'scheduleSpecifyDateText',
  };

  private readonly checklistTranslationKeys: Record<number, string> = {
    1: 'checklistUsefulText',
    2: 'checklistClearText',
    3: 'checklistValueText',
  };


  constructor(private _planservice: PlanService,private translationService:TranslationService) {

  }
  ngOnInit(): void {

    this.translationService.getTranslation().subscribe({
      next: (translation) => {
        this.translations = translation
        this.applyScheduleTranslations();
        this.applyChecklistTranslations();
      }
    })

    this._planservice.getPlanAndReminderSchedule().subscribe({
      next: (data) => {
        this.planAndReminderSchedule = data
        this.applyScheduleTranslations();
      }
    })

    this._planservice.getPlanCheckListItems().subscribe({
      next: (data) => {
        this.planCheckListItems = data
        this.applyChecklistTranslations();
      }
    })

    this._planservice.getDaysOfWeek().subscribe({
      next: (resp) => {
        this.daysOfWeek = resp
      }
    })

    for (var i = 1; i < 32; i++) {
      this.datesOfMonth.push(i)
    }
    this.onReminderDropDownChange()
  }

  private applyScheduleTranslations(): void {
    if (!this.translations || !this.planAndReminderSchedule?.length) {
      return;
    }
    this.planAndReminderSchedule = this.planAndReminderSchedule.map((item: any) => ({
      ...item,
      description: this.translations[this.scheduleTranslationKeys[item.id]] || item.description
    }));
  }

  private applyChecklistTranslations(): void {
    if (!this.translations || !this.planCheckListItems?.length) {
      return;
    }
    this.planCheckListItems = this.planCheckListItems.map((item: any) => ({
      ...item,
      description: this.translations[this.checklistTranslationKeys[item.id]] || item.description
    }));
  }

  isItemChecked(item: any, selectedItems: any[]): boolean {

    if (selectedItems === undefined)
      return false;
    return selectedItems.some((selectedItem) => selectedItem.id === item.id);
  }


  // Method to handle changes in the checkbox selection
  onCheckboxChange(event: any, itemId: number) {
    if (event.target.checked) {
      this.planDetails.planChecklist.push({ id: itemId });
    } else {
      const index = this.planDetails.planChecklist.findIndex(item => item.id === itemId);
      if (index > -1) {
        this.planDetails.planChecklist.splice(index, 1);
      }
    }


  }

  onPlanExecutionDurationChange() {
    if (this.planDetails.whenAreYouGoingToDoIt == 6) {
      this.planDetails.showPlanSpecificDateField = true
    }
    else {
      this.planDetails.showPlanSpecificDateField = false
    }
  }

  openReminderBox() {
    this.planDetails.showReminderDiv = true
  }
  closeReminderDiv() {
    this.planDetails.showReminderDiv = false
    this.resetReminderDiv();
  }
  resetReminderDiv() {
    this.planDetails.reminderFrequency = null;
    this.planDetails.reminderTime = '';
    this.planDetails.reminderMonthlyDate = null;
    this.planDetails.reminderWeeklyDayOfWeek = null;
    this.planDetails.reminderSpecificDate = null;
  }

  onReminderDropDownChange() {
    this.planDetails.showReminderDayOfWeek = false;
    this.planDetails.showReminderDateOfMonth = false;
    this.planDetails.showReminderSpecificDate = false;
    this.planDetails.reminderMonthlyDate = null;
    this.planDetails.reminderWeeklyDayOfWeek = null;
    this.planDetails.reminderSpecificDate = null
    switch (this.planDetails.reminderFrequency) {
      case 4:
        this.planDetails.showReminderDayOfWeek = true;
        break;
      case 5:
        this.planDetails.showReminderDateOfMonth = true;
        break;
      case 6:
        this.planDetails.showReminderSpecificDate = true;
        break;

    }
  }

  validateRequiredFields(): boolean {
    console.log(this.planDetails.reminderFrequency)
    let flag = true;
    if (this.planDetails.planName == '' || this.planDetails.planName == null) {
      flag = false
    }
    if (this.planDetails.whatAreYouGoingToDo == '' || this.planDetails.whatAreYouGoingToDo == null) {
      flag = false
    }
    if (this.planDetails.reminderFrequency != 0 && this.planDetails.reminderFrequency != null) {
      if (this.planDetails.reminderTime == '' || this.planDetails.reminderTime == null) {
        flag = false
      }
      switch (this.planDetails.reminderFrequency) {
        case 4:
          if (this.planDetails.reminderWeeklyDayOfWeek == 0|| this.planDetails.reminderWeeklyDayOfWeek == null) { flag = false }
          break;
        case 5:
          if (this.planDetails.reminderMonthlyDate == 0 || this.planDetails.reminderMonthlyDate == null) { flag = false }
          break;
        case 6:
          if (this.planDetails.reminderSpecificDate == null) { flag = false }
          break;
      }
    }
    return flag
  }

}
